// Translation strings - Spanish
const esTranslations: Record<string, string> = {
  // Navigation
  'nav.home': 'Inicio',
  'nav.dashboard': 'Análisis DCF',
  'nav.calculators': 'Calculadoras',
  'nav.market': 'Mercado',
  'nav.tools': 'Mercado',
  'nav.about': 'Sobre DCFlow',
  'nav.getStarted': 'Empezar',
  
  // Index Hero Section
  'hero.tag': 'Análisis financiero automatizado',
  'hero.title': 'Modelos DCF a partir de tus informes financieros',
  'hero.description': 'Sube un informe anual o estado financiero, y la IA extrae los datos clave para generar un modelo DCF completo. Ajusta supuestos, visualiza escenarios y obtén una valoración en minutos.',
  'hero.getStarted': 'Empezar',
  'hero.learnMore': 'Saber más',
  
  // Features Section
  'features.title': 'Qué puedes hacer',
  'features.subtitle': 'Herramientas para cada etapa del análisis',
  'features.description': 'Desde la extracción automática de datos hasta la valoración final, sin hojas de cálculo',
  'features.ocr.title': 'Extracción automática de datos',
  'features.ocr.description': 'Sube un PDF o imagen y la IA identifica y extrae los datos financieros relevantes',
  'features.ocr.feature1': 'Soporte PDF e imágenes',
  'features.ocr.feature2': 'Procesamiento multiidioma',
  'features.ocr.feature3': 'Validación en tiempo real',
  'features.dcf.title': 'Modelos DCF profesionales',
  'features.dcf.description': 'Genera valoraciones con flujos de caja descontados, análisis de sensibilidad y escenarios personalizados',
  'features.dcf.feature1': 'Proyecciones dinámicas',
  'features.dcf.feature2': 'Cálculo de WACC',
  'features.dcf.feature3': 'Análisis de valor terminal',
  'features.analytics.title': 'Visualizaciones claras',
  'features.analytics.description': 'Gráficos interactivos para entender los números de un vistazo y explorar distintos escenarios',
  'features.analytics.feature1': 'Gráficos en tiempo real',
  'features.analytics.feature2': 'Modelado de escenarios',
  'features.analytics.feature3': 'Evaluación de riesgos',

  // Platform Capabilities
  'stats.accuracy.number': '3',
  'stats.accuracy.label': 'Módulos principales',
  'stats.accuracy.subtext': 'OCR · DCF · Mercados',
  'stats.documents.number': 'PDF e IMG',
  'stats.documents.label': 'Formatos compatibles',
  'stats.documents.subtext': 'Arrastra y suelta',
  'stats.companies.number': 'IA',
  'stats.companies.label': 'Análisis con IA',
  'stats.companies.subtext': 'Extracción automática de datos',
  'stats.time.number': 'Tiempo real',
  'stats.time.label': 'Datos de mercado',
  'stats.time.subtext': 'Índices y acciones actualizados',

  // Hero additional content
  'hero.aiPowered': 'Con IA',
  'hero.financialIntelligence': 'Análisis financiero inteligente',
  'hero.additionalDescription': 'Convierte tus documentos financieros en insights útiles en minutos.',
  'hero.enterpriseSecurity': 'Seguridad avanzada',
  'hero.realTimeAnalysis': 'Análisis en tiempo real',

  // Secondary Features
  'secondary.speed.title': 'Procesamiento rápido',
  'secondary.speed.description': 'Carga y extrae datos en segundos',
  'secondary.security.title': 'Datos protegidos',
  'secondary.security.description': 'Tu información se mantiene segura',
  'secondary.processing.title': 'Siempre disponible',
  'secondary.processing.description': 'Infraestructura en la nube',
  'secondary.accuracy.title': 'Transparencia total',
  'secondary.accuracy.description': 'Revisa y edita todos los datos extraídos',
  
  // How It Works Section
  'process.tag': 'El proceso',
  'process.title': 'Cómo funciona',
  'process.description': 'Tres pasos para pasar de un documento financiero a una valoración completa',
  'process.step1.title': 'Sube tu documento',
  'process.step1.description': 'Carga un informe anual en PDF o imagen. Puedes subir varios archivos a la vez.',
  'process.step2.title': 'Extracción y procesamiento',
  'process.step2.description': 'La IA analiza el documento, extrae los datos financieros clave y genera un modelo DCF preliminar.',
  'process.step3.title': 'Ajusta y visualiza',
  'process.step3.description': 'Modifica los parámetros del modelo — tasas de crecimiento, descuento, escenarios — y observa cómo afectan a la valoración.',
  
  // CTA Section
  'cta.title': '¿Listo para automatizar tu análisis?',
  'cta.description': 'Genera modelos DCF en minutos. Sin entrada manual de datos ni hojas de cálculo.',
  'cta.button': 'Empezar ahora',
  
  // Footer
  'footer.description': 'Herramienta de análisis financiero que extrae datos de informes anuales y genera modelos DCF para apoyar tus decisiones de inversión.',
  'footer.quickLinks': 'Enlaces rápidos',
  'footer.contact': 'Contacto',
  'footer.email': 'Correo',
  'footer.address': 'Dirección',
  'footer.privacy': 'Política de privacidad',
  'footer.terms': 'Términos de servicio',
  'footer.cookies': 'Cookies',
  'footer.rights': 'Todos los derechos reservados.',
  'footer.location': 'España',
  'footer.emailUs': 'Escríbenos',
  'footer.emailAddress': 'Enviar correo a insightechpro@gmail.com',
  
  // Language Selector
  'language': 'Idioma',
  'english': 'Inglés',
  'spanish': 'Español',
  
  // Dashboard
  'dashboard.title': 'Panel de análisis financiero',
  'dashboard.description': 'Sube tus documentos financieros para extraer datos, generar modelos DCF y visualizar resultados',
  'dashboard.stockPrice': 'Precio de la acción:',
  'dashboard.enterPrice': 'Introduce precio',
  'dashboard.analysisProgress': 'Progreso del análisis',
  'dashboard.previousStep': 'Paso anterior',
  'dashboard.nextStep': 'Siguiente paso',
  'dashboard.learnMore': 'Más información sobre la plataforma',
  'dashboard.filesProcessedSuccess': 'Archivos procesados correctamente',
  'dashboard.filesProcessedDescription': 'Tus documentos han sido analizados. Puedes continuar con la extracción de datos.',
  'dashboard.dataExtractedSuccess': 'Datos financieros extraídos',
  'dashboard.dataExtractedDescription': 'Todo listo para generar tu modelo DCF con los datos extraídos.',
  'dashboard.modelCompleteSuccess': 'Modelo DCF completo',
  'dashboard.modelCompleteDescription': 'La valoración está lista para revisar.',
  'dashboard.cannotProceedError': 'Todavía no puedes avanzar',
  'dashboard.uploadFilesFirst': 'Sube y procesa al menos un archivo primero',
  'dashboard.verifyDataFirst': 'Verifica y confirma los datos extraídos antes de continuar',
  'dashboard.completeDCFFirst': 'Completa los cálculos del modelo DCF antes de continuar',
  'dashboard.actionRequired': 'Acción necesaria antes de continuar',
  
  // About Page
  'about.title': 'Sobre DCFlow',
  'about.nextGen.title': '¿Qué es DCFlow?',
  'about.nextGen.description': 'DCFlow convierte tus informes financieros en modelos de valoración listos para usar. Subes un documento, la IA extrae los datos y en minutos tienes un modelo DCF completo con gráficos, supuestos ajustables y análisis de sensibilidad — sin hojas de cálculo ni trabajo manual.',
  'about.technology.title': 'Pensado para analizar',
  'about.technology.description': 'Gráficos interactivos, análisis de sensibilidad en tiempo real y una interfaz diseñada para que te centres en lo que importa: entender los números.',
  'about.technology.feature1': 'Extracción automática de datos desde PDFs e imágenes',
  'about.technology.feature2': 'Modelos DCF con nivel profesional de detalle',
  'about.technology.feature3': 'Análisis de sensibilidad en tiempo real',
  'about.commitment.title': 'En qué creemos',
  'about.commitment.description': 'Queremos que analizar una empresa sea accesible, preciso y rápido — sin sacrificar la calidad que exige un análisis serio.',
  'about.commitment.feature1': 'Modelos financieros en mejora continua',
  'about.commitment.feature2': 'Funciona bien en cualquier dispositivo',
  'about.commitment.feature3': 'Datos precisos y actualizados',
  'about.howItWorks.title': 'Cómo funciona',
  'about.step1.title': 'Sube tu documento',
  'about.step1.description': 'Arrastra un informe anual, estado financiero o cualquier documento con datos contables.',
  'about.step2.title': 'Extracción automática',
  'about.step2.description': 'La IA lee tu documento y extrae las cifras relevantes: ingresos, costes, flujos de caja y más.',
  'about.step3.title': 'Tu modelo DCF listo',
  'about.step3.description': 'Ajusta los parámetros a tu criterio y obtén una valoración con gráficos interactivos al instante.',
  'about.cta.title': 'Empieza a analizar ahora',
  'about.cta.description': 'Sube tu primer documento financiero y genera un modelo DCF profesional en cuestión de minutos.',
  'about.cta.button': 'Ir al análisis',

  // OCR
  'ocr.extractedData': 'Datos financieros extraídos',
  'ocr.reviewEdit': 'Revisa y edita los datos extraídos antes de continuar con el análisis',
  'ocr.extractionNotices': 'Avisos de extracción',
  'ocr.rawText': 'Texto original',
  'ocr.editFinancialData': 'Editar datos financieros',
  'ocr.financialHighlights': 'Resumen financiero',
  'ocr.consolidatedIncome': 'Estado de resultados consolidado',
  'ocr.cashFlows': 'Flujos de caja',
  'ocr.balanceHighlights': 'Resumen del balance',
  'ocr.metricsOverview': 'Resumen de métricas',
  'ocr.dataEditor': 'Editor de datos',
  'ocr.dataQuality': 'Calidad de datos',
  'ocr.dataQualityAnalysis': 'Análisis de calidad de datos',
  'ocr.dataQualityDescription': 'Revisa la calidad de los datos extraídos y los niveles de confianza',
  'ocr.revenueData': 'Datos de ingresos',
  'ocr.operatingIncome': 'Resultado operativo',
  'ocr.netIncome': 'Resultado neto',
  'ocr.cashFlow': 'Flujo de caja',
  'ocr.highConfidence': 'Confianza alta',
  'ocr.mediumConfidence': 'Confianza media',
  'ocr.lowConfidence': 'Confianza baja',
  'ocr.extractedWithConfidence': 'Extraído con {{confidence}}% de confianza desde {{source}}',
  'ocr.overallDataQuality': 'Calidad general de datos',
  'ocr.dataQualityBasis': 'Basada en claridad, consistencia y completitud',
  'ocr.verifyDataWarning': 'Importante: Verifica los datos antes de continuar',
  'ocr.verifyDataDescription': 'Revisa todos los datos financieros extraídos con atención. La precisión de tu modelo DCF depende de que los valores de entrada sean correctos. Corrige lo que sea necesario en el editor.',
  'ocr.verifyDataBeforeDCF': 'Verifica los datos antes de pasar al modelo DCF',
  'ocr.confirmData': 'Confirmar datos',
  'ocr.extractedFinancialDataTitle': 'Datos financieros extraídos',
  'ocr.extractedFinancialDataDesc': 'Estos son los datos financieros extraídos de tus documentos',
  'ocr.metric': 'Métrica',
  'ocr.revenue': 'Ingresos',
  'ocr.operatingIncomeLabel': 'Resultado operativo',
  'ocr.netIncomeLabel': 'Resultado neto',
  'ocr.cashFlowLabel': 'Flujo de caja',
  'ocr.assetsLabel': 'Activos',
  'ocr.liabilitiesLabel': 'Pasivos',
  'ocr.noDataAvailable': 'No hay datos financieros disponibles. Revisa la información extraída.',
  'ocr.verifyMetricsWarning': 'Asegúrate de que las métricas extraídas son correctas',
  'ocr.verifyMetricsDescription': 'Datos incorrectos afectarán los resultados de valoración.',
  'ocr.incomeStatement': 'Estado de resultados',
  'ocr.balanceSheet': 'Balance general',
  'ocr.notes': 'Notas',
  
  // AI Configuration
  'ai.configureAPI': 'Configura tu API de IA para procesamiento inteligente de documentos',
  'ai.settingsTitle': 'Configuración de APIs de IA',
  'ai.configurationDescription': 'Configura tus APIs de IA para el procesamiento de documentos y la extracción de datos financieros. Las claves se almacenan localmente en tu navegador de forma segura.',
  'ai.securityNotice': 'Tus claves API se guardan de forma segura en el almacenamiento de sesión con ofuscación. Se eliminan automáticamente al cerrar el navegador.',
  'ai.documentProcessing': 'Procesamiento de documentos (OCR)',
  'ai.dataAnalysis': 'Análisis de datos financieros (NLP)',
  'ai.provider': 'Proveedor',
  'ai.apiKey': 'API Key',
  'ai.testConnection': 'Probar conexión',
  'ai.testing': 'Probando...',
  'ai.saveConfiguration': 'Guardar configuración',
  'ai.saving': 'Guardando...',
  'ai.delete': 'Eliminar',
  'ai.connectionSuccess': 'Conexión correcta',
  'ai.connectionError': 'Error de conexión',
  'ai.testingConnection': 'Probando conexión...',
  'ai.configurationSaved': 'Configuración guardada',
  'ai.configurationSavedDescription': 'Las configuraciones de API se han guardado y verificado correctamente.',
  'ai.configurationDeleted': 'Configuración eliminada',
  'ai.configurationDeletedDescription': 'Todas las configuraciones de API han sido eliminadas.',
  'ai.apiKeyRequired': 'API Key necesaria',
  'ai.apiKeyRequiredDescription': 'Introduce una API Key antes de probar la conexión.',
  'ai.connectionSuccessful': 'Conexión correcta',
  'ai.connectionSuccessfulDescription': 'La API Key funciona correctamente.',
  'ai.troubleshooting': '💡 Solución de problemas:',
  'ai.verifyKey': 'Verifica que tu API Key sea correcta y válida',
  'ai.openAIFormat': 'OpenAI: Las claves deben empezar con "sk-"',
  'ai.anthropicFormat': 'Anthropic: Las claves deben empezar con "sk-ant-"',
  'ai.checkCredits': 'Asegúrate de tener créditos disponibles en tu cuenta',
  'ai.checkPermissions': 'Comprueba que tu API Key tenga los permisos necesarios',
  'ai.autoModelSelection': '🤖 Selección automática de modelos:',
  'ai.autoModelDescription': 'El sistema detecta los modelos disponibles en tu cuenta y selecciona el más adecuado para cada tarea.',
  
  // AI Validation messages
  'ai.validation.apiKeyRequired': 'La API Key es obligatoria',
  'ai.validation.openAIFormat': 'Las API Keys de OpenAI deben empezar con "sk-"',
  'ai.validation.anthropicFormat': 'Las API Keys de Anthropic deben empezar con "sk-ant-"',
  'ai.validation.keyTooShort': 'La API Key parece demasiado corta',
  'ai.validation.keyCleaned': 'API Key corregida',
  'ai.validation.keyCleanedDescription': 'Se han eliminado caracteres no válidos de la API Key.',
  'ai.validation.unknownError': 'Error desconocido al verificar la conexión.',
  'ai.validation.configurationError': 'Error de configuración',

  // Document QA
  'docqa.title': 'Consultas sobre documentos',
  'docqa.description': 'Sube un documento financiero y haz preguntas sobre su contenido. Obtén respuestas basadas en los datos del documento.',
  'docqa.uploadDocument': 'Subir documento',
  'docqa.askQuestions': 'Hacer preguntas',
  'docqa.fullyLocalNote': 'El procesamiento de documentos se realiza de forma segura en tu navegador.',

  // Upload and File Processing
  'upload.title': 'Subir documentos financieros',
  'upload.description': 'Sube tus informes anuales o estados financieros',
  'upload.dropFiles': 'Arrastra archivos aquí o haz clic para seleccionar',
  'upload.supportedFormats': 'Formatos compatibles: PDF, PNG, JPG, JPEG',
  'upload.maxFileSize': 'Tamaño máximo por archivo: 10 MB',
  'upload.aiProcessing': 'Procesamiento con IA',
  'upload.aiDescription': 'Usa la IA para extraer y procesar automáticamente los datos financieros de tus documentos',
  'upload.processFiles': 'Procesar archivos',
  'upload.processing': 'Procesando...',
  'upload.processingWithAI': 'Procesando con IA...',
  'upload.processWithAI': 'Procesar con IA',
  'upload.invalidFileType': 'Tipo de archivo no válido',
  'upload.invalidFileTypeDescription': 'Solo se admiten archivos PDF e imágenes.',
  'upload.noFilesSelected': 'Ningún archivo seleccionado',
  'upload.uploadAtLeastOneFile': 'Sube al menos un archivo para procesar.',
  'upload.aiProcessingCompleted': 'Procesamiento con IA completado',
  'upload.aiProcessingCompletedDesc': '{{count}} archivo(s) procesado(s) con IA.',
  'upload.aiNotConfigured': 'IA no configurada',
  'upload.aiNotConfiguredDescription': 'Configura tu API Key antes de usar el procesamiento con IA.',
  'upload.browseFiles': 'Buscar archivos',
  'upload.or': 'O',
  'upload.securityNote': 'Los archivos se procesan de forma segura en nuestros servidores.',
  'upload.aiEnabled': 'IA activada',
  'upload.enableAI': 'Activar IA',
  'upload.processingFailed': 'Error en el procesamiento',
  'upload.processingFailedDescription': 'Ha ocurrido un error al procesar los archivos.',

  // DCF Model
  'dcf.title': 'Configuración del modelo DCF',
  'dcf.description': 'Configura los parámetros de tu modelo de flujo de caja descontado',
  'dcf.basicAssumptions': 'Supuestos básicos',
  'dcf.advancedAssumptions': 'Supuestos avanzados',
  'dcf.projections': 'Proyecciones',
  'dcf.valuation': 'Valoración',
  'dcf.assumptions': 'Supuestos',
  'dcf.sensitivityAnalysis': 'Análisis de Sensibilidad',

  // Visualization
  'viz.title': 'Visualizaciones financieras',
  'viz.description': 'Explora tus datos financieros con gráficos interactivos',

  // Navigation Steps
  'tabs.upload': 'Subir',
  'tabs.ocr': 'Extraer',
  'tabs.dcf': 'Modelo',
  'tabs.visualization': 'Visualizar',
  'tabs.docqa': 'P&R',
  'tabs.ocrFull': 'Datos extraídos',
  'tabs.dcfFull': 'Modelo DCF',
  'tabs.vizFull': 'Visualizaciones',
  'tabs.docqaFull': 'Consultas Q&A',
  'tabs.tooltip.ocr': 'Sube un documento primero para desbloquear este paso',
  'tabs.tooltip.dcf': 'Extrae o introduce datos financieros primero para desbloquear este paso',
  'tabs.tooltip.visualization': 'Completa el modelo DCF primero para desbloquear este paso',

  // AI Assistant
  'ai.title': 'Asistente financiero con IA',
  'ai.description': 'Obtén análisis e insights basados en tus datos financieros',
  'ai.askQuestion': 'Pregúntame sobre tu análisis financiero',
  'ai.helpText': 'Puedo ayudarte con decisiones de inversión, evaluación de riesgos y análisis estratégico.',
  'ai.placeholder': 'Pregunta sobre riesgos, valoración, recomendaciones...',
  'ai.send': 'Enviar',
  'ai.processing': 'Procesando...',
  'ai.error': 'No se pudo obtener respuesta del asistente. Inténtalo de nuevo.',
  'ai.suggestions.investment': '¿Cuál es tu recomendación de inversión con base en este análisis DCF?',
  'ai.suggestions.risks': '¿Cuáles son los principales riesgos a considerar para esta inversión?',
  'ai.suggestions.multiples': '¿Cómo se compara esta valoración con los múltiplos habituales del mercado?',
  'ai.suggestions.factors': '¿Qué factores podrían afectar significativamente la valoración de esta empresa?',

  // Tools Page
  'tools.title': 'Herramientas financieras',
  'tools.description': 'Calculadoras profesionales y datos de mercado en tiempo real',
  'tools.calculators': 'Calculadoras financieras',
  'tools.market': 'Datos de mercado',
  'tools.calculatorsDesc': 'DCF, interés compuesto, valor presente, TIR, ROI, CAGR y punto de equilibrio.',
  'tools.marketDesc': 'Índices en tiempo real, búsqueda de acciones, watchlist y estado del mercado.',
  'tools.backToTools': 'Volver a herramientas',
  'tools.openCalculators': 'Abrir calculadoras',
  'tools.openMarket': 'Abrir datos de mercado',
  'tools.fullAnalysis': 'Análisis completo disponible',
  'tools.fullAnalysisDesc': 'Para un modelo DCF completo con carga de documentos y análisis con IA, ve al panel de análisis.',
  'tools.goToDashboard': 'Ir al análisis',

  // Market Data
  'market.title': 'Datos de mercado',
  'market.description': 'Cotizaciones en tiempo real e indicadores económicos clave',
  'market.indicators.title': 'Indicadores de mercado',
  'market.indicators.description': 'Principales índices e indicadores económicos',
  'market.stocks.title': 'Acciones destacadas',
  'market.stocks.description': 'Cotizaciones y métricas clave de las principales empresas',
  'market.status.title': 'Estado del mercado',
  'market.status.open': 'Mercado abierto',
  'market.status.hours': 'NYSE: 9:30 AM - 4:00 PM EST',
  'market.gainers.title': 'Mayores subidas',
  'market.losers.title': 'Mayores bajadas',
  'market.stock.change': 'Variación:',
  'market.stock.volume': 'Volumen:',
  'market.stock.marketCap': 'Capitalización:',
  'market.stock.peRatio': 'Ratio P/E:',
  'market.stock.divYield': 'Rentabilidad por dividendo:',
  'market.category.indices': 'Índices bursátiles',
  'market.category.volatility': 'Volatilidad',
  'market.category.commodities': 'Materias primas',
  'market.category.currencies': 'Divisas',
  'market.category.sovereignBonds': 'Renta fija soberana',
  'market.category.crypto': 'Criptomonedas',

  // Financial Calculators
  'calc.title': 'Calculadoras financieras',
  'calc.description': 'Calculadoras profesionales para valoración y análisis de inversiones',
  'calc.dcf': 'Calculadora DCF',
  'calc.compound': 'Interés compuesto',
  'calc.presentValue': 'Valor presente',
  'calc.irr': 'Calculadora TIR',

  // DCF Calculator
  'calc.dcf.title': 'Valoración DCF rápida',
  'calc.dcf.description': 'Estima el valor intrínseco con la metodología de flujo de caja descontado',
  'calc.dcf.currentFCF': 'Flujo de caja libre actual',
  'calc.dcf.sharesOutstanding': 'Acciones en circulación',
  'calc.dcf.growthRate': 'Tasa de crecimiento (%)',
  'calc.dcf.terminalGrowth': 'Crecimiento terminal (%)',
  'calc.dcf.discountRate': 'Tasa de descuento (%)',
  'calc.dcf.calculate': 'Calcular valor justo',
  'calc.dcf.fairValue': 'Valor justo:',
  'calc.dcf.perShare': 'Por acción',
  'calc.dcf.enterpriseValue': 'Valor empresa:',
  'calc.dcf.pvProjectedFCFs': 'VA de FCL proyectados:',
  'calc.dcf.pvTerminalValue': 'VA de valor terminal:',
  'calc.dcf.terminalValueMultiple': 'Múltiplo de valor terminal:',
  'calc.dcf.impliedPERatio': 'Ratio P/E implícito:',

  // Compound Interest Calculator
  'calc.compound.title': 'Calculadora de interés compuesto',
  'calc.compound.description': 'Calcula el efecto del interés compuesto a lo largo del tiempo',
  'calc.compound.principal': 'Capital inicial',
  'calc.compound.rate': 'Tipo de interés anual (%)',
  'calc.compound.time': 'Plazo (años)',
  'calc.compound.frequency': 'Frecuencia de capitalización (por año)',
  'calc.compound.calculate': 'Calcular valor futuro',
  'calc.compound.futureValue': 'Valor futuro:',
  'calc.compound.principalResult': 'Capital:',
  'calc.compound.totalInterest': 'Intereses acumulados:',
  'calc.compound.effectiveRate': 'Tipo efectivo anual:',
  'calc.compound.totalReturn': 'Rentabilidad total:',
  'calc.compound.averageGrowth': 'Crecimiento anual medio:',

  // Present Value Calculator
  'calc.pv.title': 'Calculadora de valor presente',
  'calc.pv.description': 'Calcula el valor actual de flujos de caja futuros',
  'calc.pv.futureValue': 'Valor futuro',
  'calc.pv.discountRate': 'Tasa de descuento (%)',
  'calc.pv.timePeriod': 'Plazo (años)',
  'calc.pv.calculate': 'Calcular valor presente',
  'calc.pv.presentValue': 'Valor presente:',
  'calc.pv.futureValueResult': 'Valor futuro:',
  'calc.pv.totalDiscount': 'Descuento total:',
  'calc.pv.annualDiscountRate': 'Tasa de descuento anual:',
  'calc.pv.annualDiscountFactor': 'Factor de descuento anual:',
  'calc.pv.totalDiscountFactor': 'Factor de descuento total:',

  // IRR Calculator
  'calc.irr.title': 'Calculadora de TIR',
  'calc.irr.description': 'Calcula la tasa interna de retorno de un proyecto de inversión',
  'calc.irr.initialInvestment': 'Inversión inicial',
  'calc.irr.cashFlows': 'Flujos de caja anuales (separados por comas)',
  'calc.irr.calculate': 'Calcular TIR',
  'calc.irr.initialInvestmentResult': 'Inversión inicial:',
  'calc.irr.totalCashReturns': 'Retornos totales:',
  'calc.irr.netProfit': 'Beneficio neto:',
  'calc.irr.npvAt10': 'VAN (al 10% de descuento):',
  'calc.irr.paybackPeriod': 'Período de recuperación:',
  'calc.irr.notAchieved': 'No alcanzado en la proyección',
  'calc.irr.years': 'años',

  // ROI Calculator
  'calc.roi': 'ROI',
  'calc.roi.title': 'Calculadora de ROI',
  'calc.roi.description': 'Calcula el retorno sobre la inversión de cualquier proyecto o activo',
  'calc.roi.cost': 'Coste de inversión',
  'calc.roi.returns': 'Retornos totales',
  'calc.roi.calculate': 'Calcular ROI',
  'calc.roi.costResult': 'Coste de inversión',
  'calc.roi.returnsResult': 'Retornos totales',
  'calc.roi.profit': 'Beneficio/pérdida neto',
  'calc.roi.multiple': 'Múltiplo de retorno',

  // CAGR Calculator
  'calc.cagr': 'CAGR',
  'calc.cagr.title': 'Calculadora de CAGR',
  'calc.cagr.description': 'Calcula la tasa de crecimiento anual compuesto entre dos valores',
  'calc.cagr.beginLabel': 'Valor inicial',
  'calc.cagr.endLabel': 'Valor final',
  'calc.cagr.periodLabel': 'Plazo',
  'calc.cagr.calculate': 'Calcular CAGR',
  'calc.cagr.beginValue': 'Valor inicial',
  'calc.cagr.endValue': 'Valor final',
  'calc.cagr.totalReturn': 'Retorno total',
  'calc.cagr.years': 'Plazo',
  'calc.cagr.multiple': 'Múltiplo de crecimiento',

  // Breakeven Calculator
  'calc.breakeven': 'Punto de equilibrio',
  'calc.breakeven.title': 'Calculadora de punto de equilibrio',
  'calc.breakeven.description': 'Calcula cuántas unidades necesitas vender para cubrir todos los costes',
  'calc.breakeven.fixedLabel': 'Costes fijos',
  'calc.breakeven.priceLabel': 'Precio por unidad',
  'calc.breakeven.variableLabel': 'Coste variable por unidad',
  'calc.breakeven.calculate': 'Calcular punto de equilibrio',
  'calc.breakeven.pointLabel': 'Punto de equilibrio',
  'calc.breakeven.fixedCosts': 'Costes fijos',
  'calc.breakeven.priceUnit': 'Precio por unidad',
  'calc.breakeven.variableUnit': 'Coste variable por unidad',
  'calc.breakeven.contributionMargin': 'Margen de contribución',
  'calc.breakeven.revenue': 'Ingresos en punto de equilibrio',
  'calc.breakeven.unitsLabel': 'unidades',

  // Calculator tooltips
  'calc.tip.fcf': 'Flujo de caja operativo menos inversiones en capital',
  'calc.tip.shares': 'Total de acciones diluidas en circulación',
  'calc.tip.growth': 'Tasa de crecimiento anual de ingresos esperada',
  'calc.tip.terminalGrowth': 'Tasa de crecimiento sostenible a largo plazo (normalmente 2-3%)',
  'calc.tip.wacc': 'Coste medio ponderado del capital (WACC)',
  'calc.tip.principal': 'Capital inicial de inversión',
  'calc.tip.futureValue': 'El importe que esperas recibir en el futuro',
  'calc.tip.initialInv': 'Importe total invertido inicialmente',
  'calc.tip.cashFlows': 'Retornos anuales esperados, separados por comas',
  'calc.validation.discountRate': 'La tasa de descuento debe ser mayor que la tasa de crecimiento terminal',

  // Comparison mode
  'calc.compare.toggle': 'Modo comparación',
  'calc.compare.saveScenario': 'Guardar escenario',
  'calc.compare.scenarioName': 'Nombre del escenario',
  'calc.compare.savedScenarios': 'Escenarios guardados',
  'calc.compare.noScenarios': 'Calcula y guarda escenarios para compararlos entre sí',
  'calc.compare.clear': 'Borrar todo',
  'calc.compare.remove': 'Eliminar',
  'calc.compare.vsBaseline': 'vs base',
  'calc.compare.result': 'Resultado',
  'calc.compare.exportCSV': 'Exportar CSV',
  'calc.compare.exportPDF': 'Exportar PDF',
  'calc.compare.export': 'Exportar',
  'calc.compare.metric': 'Métrica',
  'calc.compare.scenarioComparison': 'Comparación de escenarios',
  'calc.compare.generatedOn': 'Generado el',
  'calc.compare.difference': 'Diferencia',
  'calc.validation.priceAboveVariable': 'El precio debe ser superior al coste variable por unidad',

  // Chatbot
  'chatbot.title': 'Asistente financiero',
  'chatbot.poweredBy': 'Con IA',
  'chatbot.thinking': 'Pensando...',
  'chatbot.placeholder': 'Haz una pregunta financiera...',
  'chatbot.welcome.title': 'Asistente financiero',
  'chatbot.welcome.description': 'Pregúntame sobre inversión, valoración, mercados, contabilidad o cualquier tema financiero.',
  'chatbot.welcome.q1': '¿Qué es una valoración DCF?',
  'chatbot.welcome.q2': 'Explica el ratio P/E',
  'chatbot.welcome.q3': '¿Cómo funciona el WACC?',
  'chatbot.welcome.q4': '¿EBITDA vs resultado neto?',
  'chatbot.clear': 'Borrar conversación',
  'chatbot.open': 'Abrir asistente financiero',

  // Dashboard steps
  'dashboard.step.upload': 'Subir',
  'dashboard.step.extraction': 'Extraer datos',
  'dashboard.step.dcf': 'Modelo DCF',
  'dashboard.step.visualization': 'Resultados',
  'dashboard.step.uploadDesc': 'Sube tus informes financieros (PDF o imágenes) para empezar.',
  'dashboard.step.extractionDesc': 'Revisa y verifica los datos extraídos, o introdúcelos manualmente.',
  'dashboard.step.dcfDesc': 'Configura los supuestos y ejecuta el modelo de flujo de caja descontado.',
  'dashboard.step.visualizationDesc': 'Explora gráficos interactivos, análisis de sensibilidad y resultados de valoración.',
  'dashboard.keyboardHint': 'Tip: Usa las teclas ← → para navegar entre pasos',

  // Clear Data
  'dashboard.clearData.button': 'Borrar datos',
  'dashboard.clearData.title': '¿Borrar todos los datos?',
  'dashboard.clearData.description': 'Se eliminarán todos los archivos subidos, datos extraídos, información financiera y resultados DCF. Esta acción no se puede deshacer.',
  'dashboard.clearData.cancel': 'Cancelar',
  'dashboard.clearData.confirm': 'Borrar todo',
  'dashboard.clearData.success': 'Datos borrados',
  'dashboard.clearData.successDesc': 'Listo para un nuevo análisis',

  // Quick Stats
  'quickStats.revenue': 'Ingresos',
  'quickStats.netIncome': 'Resultado neto',
  'quickStats.freeCashFlow': 'Flujo de caja libre',
  'quickStats.impliedPrice': 'Precio implícito',
  'quickStats.noData': 'Sube o introduce datos financieros para ver las métricas clave aquí.',

  // Financial Constellation Nodes
  'node.revenue.label': 'Revenue',
  'node.revenue.description': 'Ingresos totales por ventas antes de gastos',
  'node.revenue.details': 'Los ingresos son el punto de partida de cualquier modelo DCF: representan el total facturado por la venta de bienes o servicios. La evolución histórica de los ingresos determina las tasas de crecimiento que proyectan los flujos de caja futuros.\n\nFórmula:\nIngresos = Precio × Unidades vendidas\nTasa de crecimiento = (Ingresos₁ − Ingresos₀) / Ingresos₀',

  'node.ebitda.label': 'EBITDA',
  'node.ebitda.description': 'Beneficio antes de intereses, impuestos, D&A',
  'node.ebitda.details': 'El EBITDA mide la rentabilidad operativa eliminando el efecto de decisiones financieras y contables. Permite comparar empresas de forma homogénea al aislar el rendimiento del negocio principal.\n\nFórmula:\nEBITDA = Ingresos − Coste de ventas − Gastos operativos + D&A\no equivalentemente:\nEBITDA = Beneficio neto + Intereses + Impuestos + D&A',

  'node.capex.label': 'CapEx',
  'node.capex.description': 'Inversiones en activos a largo plazo',
  'node.capex.details': 'El CapEx (Capital Expenditures) recoge las inversiones en inmovilizado material: instalaciones, maquinaria y equipamiento. Se resta al calcular el flujo de caja libre porque representa efectivo ya comprometido en el negocio.\n\nFórmula:\nCapEx = Inmovilizado (final) − Inmovilizado (inicio) + Amortización',

  'node.fcf.label': 'FCF',
  'node.fcf.description': 'Flujo de caja libre para inversores',
  'node.fcf.details': 'El flujo de caja libre (Free Cash Flow) es el efectivo que genera la empresa tras cubrir gastos operativos e inversiones de capital. Es el dinero realmente disponible para retribuir a accionistas, reducir deuda o reinvertir.\n\nFórmula:\nFCF = EBIT × (1 − Tasa impositiva) + D&A − CapEx − ΔCapital circulante',

  'node.discount.label': 'Tasa de descuento',
  'node.discount.description': 'Tipo para descontar flujos futuros',
  'node.discount.details': 'La tasa de descuento refleja el valor temporal del dinero y el riesgo de la inversión. Cuanto mayor sea, menor será el valor presente de los flujos futuros, indicando mayor incertidumbre.\n\nEn modelos DCF se suele usar el WACC como tasa de descuento.\n\nFórmula:\nVA = FCFₜ / (1 + r)ᵗ\ndonde r = tasa de descuento, t = año',

  'node.wacc.label': 'WACC',
  'node.wacc.description': 'Coste medio ponderado del capital',
  'node.wacc.details': 'El WACC combina el coste del capital propio (CAPM) y el coste de la deuda después de impuestos, ponderados según su peso en la estructura de capital. Representa la rentabilidad mínima exigida por todos los proveedores de capital.\n\nFórmula:\nWACC = (E/V) × Ke + (D/V) × Kd × (1 − T)\ndonde Ke = coste del equity, Kd = coste de la deuda, T = tipo impositivo',

  'node.terminal.label': 'Valor Terminal',
  'node.terminal.description': 'Valor más allá del período de proyección',
  'node.terminal.details': 'El valor terminal captura el valor de la empresa más allá del horizonte explícito de proyección. Suele representar entre el 60 % y el 80 % del valor total de la empresa, por lo que los supuestos de crecimiento y descuento son críticos.\n\nModelo de Gordon:\nVT = FCFₙ × (1 + g) / (WACC − g)\n\nMétodo de múltiplo de salida:\nVT = EBITDAₙ × Múltiplo de salida',

  'node.npv.label': 'VAN',
  'node.npv.description': 'Valor actual neto de todos los flujos',
'node.npv.details': 'El Valor Actual Neto (VAN) suma todos los flujos de caja futuros descontados y resta la inversión inicial. Un VAN positivo indica que la inversión crea valor; uno negativo, que lo destruye.\n\nFórmula:\nVAN = Σ [FCFₜ / (1 + r)ᵗ] + VT / (1 + r)ⁿ',

  // Profile
  'profile.title': 'Mi Perfil',
  'profile.subtitle': 'Gestiona la configuración de tu cuenta',
  'profile.accountInfo': 'Información de la cuenta',
  'profile.email': 'Correo electrónico',
  'profile.displayName': 'Nombre para mostrar',
  'profile.displayNamePlaceholder': 'Introduce tu nombre',
  'profile.memberSince': 'Miembro desde',
  'profile.saveChanges': 'Guardar cambios',
  'profile.saving': 'Guardando...',
  'profile.saved': 'Perfil actualizado',
  'profile.error': 'Error al actualizar el perfil',
  'profile.signOut': 'Cerrar sesión',
  'profile.backToDashboard': 'Volver al Dashboard',
  'nav.profile': 'Perfil',

  // Pipeline Upload Zone
  'pipeline.dropTitle': 'Arrastra tu informe financiero aquí',
  'pipeline.dropSubtitle': 'PDF — Informes anuales, estados financieros',
  'pipeline.or': 'o',
  'pipeline.selectPDF': 'Seleccionar archivo PDF',
  'pipeline.readyToAnalyze': 'Listo para analizar',
  'pipeline.processWithAI': 'Procesar con IA',
  'pipeline.changeFile': 'Cambiar archivo',
  'pipeline.manualEntry': 'O ingresa datos financieros manualmente',

  // Pipeline Progress
  'pipeline.uploading': 'Subiendo documento...',
  'pipeline.analyzing': 'Analizando documento con IA. Esto puede tardar hasta 60 segundos...',
  'pipeline.generatingDCF': 'Construyendo modelo de valoración...',
  'pipeline.errorDefault': 'Ha ocurrido un error.',
  'pipeline.retry': 'Intentar de nuevo',

  // Extraction Review
  'extraction.metric': 'Métrica',
  'extraction.editedByUser': 'Editado por el usuario',
  'extraction.lowConfidence': 'Confianza baja',
  'extraction.extractedByAI': 'Extraído por IA',
  'extraction.edited': 'Editado',
  'extraction.generateDCF': 'Generar Modelo DCF',

  // DCF Pipeline Results
  'dcf.impliedSharePrice': 'Precio Implícito por Acción',
  'dcf.regenerateWithAI': 'Regenerar con IA',
  'dcf.concept': 'Concepto',
  'dcf.yearN': 'Año',
  'dcf.waccVsTerminal': 'WACC \\ Crec. Terminal',
  'dcf.terminalGrowth': 'Crecimiento Terminal',
  'dcf.taxRate': 'Tasa Impositiva',
  'dcf.capexPctRevenue': 'CapEx (% Ingresos)',
  'dcf.revenueGrowth': 'Crecimiento de Ingresos',
  'dcf.ebitdaMargin': 'Margen EBITDA',
  'dcf.taxes': 'Impuestos',
  'dcf.wcChanges': 'Δ Capital de Trabajo',

  // OCR Extraction page
  'ocr.financialDataInput': 'Entrada de datos financieros',
  'ocr.financialDataInputDesc': 'Sube documentos para extracción con IA, o introduce los datos financieros manualmente. Puedes revisar y editar los datos antes de continuar al modelo DCF.',

  // EmptyState
  'ocr.empty.uploadDocument': 'Subir documento',
  'ocr.empty.enterManually': 'Introducir manualmente',
  'ocr.empty.noDocUploaded': 'No se ha subido ningún documento',
  'ocr.empty.noDocDescription': 'Sube un documento financiero (PDF, PNG, JPG) en la pestaña Subir para extraer datos financieros para el análisis DCF.',
  'ocr.empty.supportedDocs': 'Documentos compatibles',
  'ocr.empty.annualReports': 'Informes anuales (10-K)',
  'ocr.empty.quarterlyReports': 'Informes trimestrales (10-Q)',
  'ocr.empty.incomeStatements': 'Estados de resultados',
  'ocr.empty.balanceSheets': 'Balances generales',
  'ocr.empty.cashFlowStatements': 'Estados de flujo de caja',
  'ocr.empty.manualNotAvailable': 'La entrada manual de datos no está disponible en este momento.',

  // ManualDataEntry
  'manual.title': 'Entrada manual de datos',
  'manual.description': 'Introduce los datos financieros directamente. Usa los sufijos <strong>K, M, B, T</strong> (ej: "97.7B" = $97.700 millones). Los campos marcados con <span class="text-destructive">*</span> son obligatorios para el modelo DCF.',
  'manual.companyName': 'Nombre de la empresa',
  'manual.companyPlaceholder': 'ej: Tesla, Inc.',
  'manual.sharesOutstanding': 'Acciones en circulación',
  'manual.sharesTooltip': 'Total de acciones diluidas — se usa para calcular el precio por acción en el DCF',
  'manual.sharesPlaceholder': 'ej: 3.2B o 3200M',
  'manual.addYear': 'Añadir año',
  'manual.remove': 'Eliminar',
  'manual.incomeStatement': 'Estado de resultados',
  'manual.cashFlow': 'Flujo de caja',
  'manual.balanceSheet': 'Balance general',
  'manual.revenue': 'Ingresos',
  'manual.revenuePlaceholder': 'ej: 97.7B',
  'manual.revenueTooltip': 'Ingresos totales / ventas netas',
  'manual.costOfRevenue': 'Coste de ventas',
  'manual.costOfRevenuePlaceholder': 'ej: 80B',
  'manual.costOfRevenueTooltip': 'Coste de los bienes vendidos (COGS)',
  'manual.operatingExpenses': 'Gastos operativos',
  'manual.operatingExpensesPlaceholder': 'ej: 10B',
  'manual.operatingExpensesTooltip': 'SG&A + I+D + otros gastos operativos',
  'manual.operatingIncome': 'Resultado operativo',
  'manual.operatingIncomePlaceholder': 'ej: 7B',
  'manual.operatingIncomeTooltip': 'Ingresos - COGS - OpEx (EBIT)',
  'manual.netIncome': 'Resultado neto',
  'manual.netIncomePlaceholder': 'ej: 7.5B',
  'manual.netIncomeTooltip': 'Beneficio final después de todos los gastos e impuestos',
  'manual.ebitda': 'EBITDA',
  'manual.ebitdaPlaceholder': 'ej: 12B',
  'manual.ebitdaTooltip': 'Beneficio antes de intereses, impuestos, depreciación y amortización',
  'manual.operatingCashFlow': 'Flujo de caja operativo',
  'manual.operatingCashFlowPlaceholder': 'ej: 14.9B',
  'manual.operatingCashFlowTooltip': 'Efectivo generado por las operaciones principales',
  'manual.capex': 'Inversiones de capital',
  'manual.capexPlaceholder': 'ej: 11.3B',
  'manual.capexTooltip': 'Inversión en PP&E y activos a largo plazo',
  'manual.depreciation': 'Depreciación y amortización',
  'manual.depreciationPlaceholder': 'ej: 4.5B',
  'manual.depreciationTooltip': 'Cargo no monetario por desgaste de activos — ajusta automáticamente el ratio D&A/CapEx en DCF',
  'manual.totalAssets': 'Activos totales',
  'manual.totalAssetsPlaceholder': 'ej: 122B',
  'manual.totalAssetsTooltip': 'Suma de todos los activos del balance',
  'manual.totalLiabilities': 'Pasivos totales',
  'manual.totalLiabilitiesPlaceholder': 'ej: 48B',
  'manual.totalLiabilitiesTooltip': 'Suma de todos los pasivos',
  'manual.shareholdersEquity': 'Patrimonio neto',
  'manual.shareholdersEquityPlaceholder': 'ej: 72B',
  'manual.shareholdersEquityTooltip': 'Activos totales menos pasivos totales',
  'manual.totalDebt': 'Deuda total',
  'manual.totalDebtPlaceholder': 'ej: 15B',
  'manual.totalDebtTooltip': 'Deuda a corto + largo plazo — ajusta automáticamente el ratio D/E en DCF',
  'manual.revenueRequired': 'Datos de ingresos necesarios',
  'manual.revenueRequiredDesc': 'Introduce los ingresos de al menos un año.',
  'manual.validationHint': 'Para un modelo DCF preciso, introduce al menos los <strong>Ingresos</strong>, el <strong>Resultado operativo</strong> y el <strong>Resultado neto</strong> de uno o más años.',
  'manual.years': 'años',
  'manual.fields': 'campos',
  'manual.saveContinue': 'Guardar y continuar al DCF',

  // ManualDataSummary
  'summary.dataReady': 'Datos financieros listos',
  'summary.manualComplete': 'Entrada manual completada. Los datos están listos para el modelo DCF.',
  'summary.revenue': 'Ingresos',
  'summary.fiscalYears': 'años fiscales',
  'summary.metricsEntered': 'métricas introducidas',
  'summary.reEnter': 'Reintroducir datos',

  // ProcessingSteps
  'processing.steps': 'Pasos de procesamiento',
  'processing.step1': 'Análisis del documento',
  'processing.step2': 'Extracción de texto',
  'processing.step3': 'Identificación de datos financieros',
  'processing.step4': 'Estructuración y preparación de datos',

  // ProcessingLoader
  'processing.title': 'Procesando tus documentos',
  'processing.stepOf': 'Paso {{current}} de {{total}}',
  'processing.hint': 'Los datos extraídos estarán disponibles para revisión y edición manual antes de usarse en el modelo DCF.',

  // DataValidationAlert
  'validation.dataReady': '¡Datos listos!',
  'validation.actionRequired': 'Acción requerida:',
  'validation.allFieldsPresent': 'Todos los campos financieros clave están presentes y listos para el modelo DCF.',
  'validation.missingFields': 'Algunos campos faltan o están incompletos. Revisa los datos antes de continuar.',

  // DCFRequirements
  'dcfReq.title': 'Requisitos del modelo DCF',
  'dcfReq.complete': 'Completo',
  'dcfReq.required': 'Requerido',
  'dcfReq.canUseAssumptions': 'Puede usar supuestos',
  'dcfReq.missing': 'Falta',
  'dcfReq.willUseAssumptions': 'Usará supuestos basados en:',
  'dcfReq.missingDataQuestion': '¿Faltan datos?',
  'dcfReq.missingDataHint': 'Puedes continuar usando supuestos estándar de la industria para los campos faltantes.',
  'dcfReq.useAssumptions': 'Usar supuestos',
  'dcfReq.usingAssumptions': '✓ Usando supuestos',
  'dcfReq.revenueRequired': 'Datos de ingresos requeridos:',
  'dcfReq.revenueRequiredDesc': 'Sube un documento financiero o introduce manualmente los datos de ingresos para continuar.',
  'dcfReq.cashFlow.label': 'Flujo de caja libre o componentes',
  'dcfReq.cashFlow.desc': 'Flujo de caja operativo e inversiones de capital, o datos directos de FCF',
  'dcfReq.balance.label': 'Datos del balance',
  'dcfReq.balance.desc': 'Activos totales, pasivos y patrimonio para calcular deuda neta y valor de empresa',
  'dcfReq.income.label': 'Estado de resultados principal',
  'dcfReq.income.desc': 'Ingresos, resultado operativo y resultado neto para análisis de crecimiento',
  'dcfReq.history.label': 'Datos históricos (1+ años)',
  'dcfReq.history.desc': 'Se requiere al menos 1 año de datos, 3+ recomendados para análisis de tendencias',
  'dcfReq.history.missing': 'Al menos 1 año de datos',
  'dcfReq.wacc.label': 'Datos para cálculo de WACC',
  'dcfReq.wacc.desc': 'Datos de mercado y ratios de deuda (usará valores estándar si faltan)',

  // DCFMain
  'dcfMain.noData': 'No hay datos financieros disponibles',
  'dcfMain.completeExtraction': 'Completa el paso de extracción primero.',
  'dcfMain.calculating': 'Calculando modelo DCF',
  'dcfMain.processingData': 'Procesando datos financieros y generando proyecciones...',

  // DCFModel (empty state)
  'dcfModel.waiting': 'Esperando datos financieros',
  'dcfModel.uploadPrompt': 'Sube un informe anual para extraer datos financieros',

  // Visualization
  'viz.tabOverview': 'General',
  'viz.tabHistorical': 'Histórico',
  'viz.tabProjections': 'Proyecciones',
  'viz.tabValuation': 'Valoración',
  'viz.revenueNetIncome': 'Ingresos y resultado neto',
  'viz.revenueNetIncomeDesc': 'Ingresos y resultado neto históricos y proyectados',
  'viz.cashFlows': 'Flujos de caja',
  'viz.cashFlowsDesc': 'Flujos de caja históricos y proyectados',
  'viz.revenue': 'Ingresos',
  'viz.netIncome': 'Resultado neto',
  'viz.operatingCashFlow': 'Flujo de caja operativo',
  'viz.freeCashFlow': 'Flujo de caja libre',
  'viz.discountedFCF': 'FCF descontado',
  'viz.valueComposition': 'Composición del valor',
  'viz.pvFCF': 'VA del FCF',
  'viz.pvTerminalValue': 'VA del valor terminal',
  'viz.operatingNetMargins': 'Márgenes operativo y neto',
  'viz.operatingMargin': 'Margen operativo',
  'viz.netMargin': 'Margen neto',
  'viz.growthRates': 'Tasas de crecimiento',
  'viz.yoyRevenueGrowth': 'Crecimiento interanual de ingresos',
  'viz.historicalRevenue': 'Ingresos históricos',
  'viz.yoyGrowth': 'Crecimiento interanual de ingresos',
  'viz.historicalProfitability': 'Rentabilidad histórica',
  'viz.opIncomeNetIncomeTrends': 'Tendencias de resultado operativo y neto',
  'viz.operatingIncome': 'Resultado operativo',
  'viz.historicalSummary': 'Resumen financiero histórico',
  'viz.keyMetricsOverTime': 'Métricas financieras clave a lo largo del tiempo',
  'viz.metric': 'Métrica',
  'viz.cashFlow': 'Flujo de caja',
  'viz.projectedRevenue': 'Ingresos proyectados',
  'viz.revenueForecast': 'Previsión de ingresos para los próximos {{n}} años',
  'viz.projectedCashFlows': 'Flujos de caja proyectados',
  'viz.fcfAndDiscountedForecast': 'Previsión de flujo de caja libre y flujo descontado',
  'viz.projectedSummary': 'Resumen financiero proyectado',
  'viz.keyProjectedMetrics': 'Métricas financieras proyectadas clave',
  'viz.year': 'Año',
  'viz.ebit': 'EBIT',
  'viz.dcfModelResults': 'Resultados del modelo DCF',
  'viz.valuationBreakdown': 'Desglose detallado de los componentes de valoración',
  'viz.sharePrice': 'Precio por acción',
  'viz.enterpriseValue': 'Valor de empresa',
  'viz.equityValue': 'Valor del patrimonio',
  'viz.terminalValue': 'Valor terminal',
  'viz.valuationComponents': 'Componentes de valoración',
  'viz.pctBreakdown': 'Desglose porcentual del valor de empresa',
  'viz.sensitivityAnalysis': 'Análisis de sensibilidad',
  'viz.sensitivityDesc': 'Impacto de la tasa de descuento y el crecimiento terminal en la valoración',
  'viz.discountRateVsTerminal': 'Tasa desc. \\ Crec. terminal',

  // Upload components
  'upload.selectedFiles': 'Archivos seleccionados',
  'upload.processingFiles': 'Procesando archivos...',

  // StepNavigation mobile
  'nav.next': 'Sig.',
  'nav.prev': 'Ant.',
  'nav.learnMoreShort': 'Más info',

  // Dashboard error messages
  'dashboard.missingRequiredData': 'Faltan datos obligatorios',

  // Saved Analyses
  'savedAnalyses.title': 'Análisis anteriores',
  'savedAnalyses.description': 'Carga un análisis previo para retomar tu trabajo',
  'savedAnalyses.empty': 'No hay análisis anteriores. Sube un documento para empezar.',
  'savedAnalyses.load': 'Cargar',
  'savedAnalyses.status.uploading': 'Subiendo',
  'savedAnalyses.status.analyzing': 'Analizando',
  'savedAnalyses.status.extracted': 'Extraído',
  'savedAnalyses.status.generating_dcf': 'Generando DCF',
  'savedAnalyses.status.dcf_generated': 'Completo',
  'savedAnalyses.status.error': 'Error',
  'savedAnalyses.loadSuccess': 'Análisis cargado',
  'savedAnalyses.loadSuccessDesc': 'Los datos del análisis anterior se han restaurado.',
  'savedAnalyses.noData': 'Sin datos disponibles',
  'savedAnalyses.noDataDesc': 'Este análisis no tiene datos recuperables.',
  'savedAnalyses.unknownCompany': 'Empresa desconocida',

  // Market — Búsqueda de acciones
  'market.search.title': 'Buscador de acciones',
  'market.search.placeholder': 'Busca por símbolo o empresa (ej.: AAPL, Apple)',
  'market.search.noResults': 'Sin resultados',
  'market.search.failed': 'La búsqueda ha fallado. Inténtalo de nuevo.',
  'market.search.marketCap': 'Capitalización',
  'market.search.volume': 'Volumen',
  'market.search.peRatio': 'Ratio P/E',
  'market.search.divYield': 'Rentab. dividendo',
  'market.search.high52w': 'Máx. 52s',
  'market.search.low52w': 'Mín. 52s',
  'market.search.inWatchlist': 'En watchlist',
  'market.search.addToWatchlist': 'Añadir a watchlist',

  // Market — Watchlist
  'market.watchlist.title': 'Mi watchlist',
  'market.watchlist.signInPrompt': 'Inicia sesión para crear y gestionar tu watchlist personal',
  'market.watchlist.signIn': 'Iniciar sesión',
  'market.watchlist.empty': 'Tu watchlist está vacía',
  'market.watchlist.emptyHint': 'Busca acciones arriba y añádelas a tu watchlist',
  'market.watchlist.refresh': 'Actualizar',
  'market.watchlist.export': 'Exportar CSV',
  'market.watchlist.notes': 'Notas',
  'market.watchlist.notesPlaceholder': 'Añade una nota corta (ej.: objetivo 180 $)',
  'market.watchlist.editNote': 'Editar nota',
  'market.watchlist.saveNote': 'Guardar',
  'market.watchlist.cancelNote': 'Cancelar',
  'market.watchlist.noteSaved': 'Nota guardada',
  'market.watchlist.noteSaveError': 'No se pudo guardar la nota',
  'market.watchlist.csvHeaders': 'Símbolo,Nombre,Precio,Variación,Variación %,Notas',

  // Market — Toasts de watchlist
  'market.watchlist.signInRequired': 'Inicio de sesión requerido',
  'market.watchlist.signInRequiredDesc': 'Inicia sesión para añadir acciones a tu watchlist',
  'market.watchlist.alreadyAdded': 'Ya está en la watchlist',
  'market.watchlist.alreadyAddedDesc': '{symbol} ya está en tu watchlist',
  'market.watchlist.added': 'Añadido a la watchlist',
  'market.watchlist.addedDesc': '{symbol} se ha añadido a tu watchlist',
  'market.watchlist.removed': 'Eliminado de la watchlist',
  'market.watchlist.removedDesc': '{symbol} se ha eliminado de tu watchlist',
  'market.watchlist.error': 'Error',
  'market.watchlist.addError': 'No se pudo añadir a la watchlist',
  'market.watchlist.removeError': 'No se pudo eliminar de la watchlist',

  // Market — Estado del mercado
  'market.status.noGainers': 'Sin subidas hoy',
  'market.status.noLosers': 'Sin bajadas hoy',
};

export default esTranslations;
